import Vue from "vue";
import _ from "lodash";

export const buildingsService = {
  list,
  getById,
  create,
  update
};

function list(params) {
  if (_.get(params, "state_agency")) {
    return Vue.axios.get(
      `v2/manager/state_agencies/${params.state_agency}/buildings`,
      { params }
    );
  } else {
    return Vue.axios.get("v1/buildings", { params });
  }
}

function getById(id) {
  return Vue.axios.get(`v1/buildings/${id}`);
}

function create(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("corporate_tax_id", payload.corporate_tax_id);
  formData.set("contact_phone_number", payload.contact_phone_number);
  formData.set("contact_name", payload.contact_name);
  formData.set("company_id", payload.company_id);
  formData.set("region_id", payload.region_id);
  formData.set("presale", payload.presale);

  if (payload.logo) {
    formData.set("logo", payload.logo);
  }

  if (payload.banner) {
    formData.set("banner", payload.banner);
  }

  return Vue.axios.post("v1/buildings", formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}

function update(payload) {
  const formData = new FormData();

  formData.set("name", payload.name);
  formData.set("corporate_tax_id", payload.corporate_tax_id);
  formData.set("contact_phone_number", payload.contact_phone_number);
  formData.set("contact_name", payload.contact_name);
  formData.set("region_id", payload.region_id);
  formData.set("presale", payload.presale);

  if (payload.logo) {
    formData.set("logo", payload.logo);
  }

  if (payload.banner) {
    formData.set("banner", payload.banner);
  }

  return Vue.axios.patch(`v1/buildings/${payload.id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
}
